import * as React from 'react';
import {Provider} from 'react-redux';

import {store} from '../../../store';

import {TimelineCreatorEmail} from '../../timeline/creator/timeline-creator-email';
import type {OwnProps as TimelineCreatorEmailProps} from '../../timeline/creator/timeline-creator-email';

type Props = TimelineCreatorEmailProps;

/**
 * A trigger component that gives Redux store access via Provider to populate
 * modal data such as templates and sender/recipient, and uses
 * TimelineCreatorEmail to dispatch the event to open the email modal
 */
export function EmailModalWrapper(props: Props) {
    return (
        <Provider store={store}>
            <TimelineCreatorEmail
                entityId={props.entityId}
                postModalOpen={props.postModalOpen}
                originSalesDocumentType={props.originSalesDocumentType}
                seededWithEmailAddress={props.seededWithEmailAddress}
                seedWithAllPrimaryRelatedEmailAddresses={
                    props.seedWithAllPrimaryRelatedEmailAddresses
                }
            />
        </Provider>
    );
}
